import { useLang } from '../utils/hooks'
import { langLogin } from '../assets/langLogin'
import { Link } from 'react-router-dom'

const LoginBox = ({
  badEntries,
  emailOK,
  email,
  onEmailChange,
  pwdOK,
  pwd,
  onPwdChange,
  onPwdLost,
  onSubmit,
}) => {
  const { lang } = useLang()
  const choosenLang = lang === 'fr' ? langLogin.fr : langLogin.eng

  return (
    <>
      {badEntries && (
        <div className="notification is-danger is-light">
          <span className="icon is-small is-left">
            <i className="fa fa-exclamation-triangle"></i>
          </span>
          {'  '}
          {choosenLang.alertNotCorrect}
        </div>
      )}

      <div className="field">
        <label className="label">{choosenLang.address}</label>
        <div className="control has-icons-left has-icons-right">
          <input
            id="email"
            className={'input ' + (emailOK ? 'is-primary' : 'is-danger')}
            type="email"
            placeholder={choosenLang.address}
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
          <span className="icon is-small is-left">
            <i className="fa fa-envelope"></i>
          </span>
          {!emailOK && (
            <span className="icon is-small is-right">
              <i className="fa fa-exclamation-triangle"></i>
            </span>
          )}
        </div>
        <p className="help is-danger">
          {emailOK ? '' : email.length > 0 ? choosenLang.alertAddress : ''}
        </p>
      </div>

      <div className="field">
        <label className="label">{choosenLang.pwd}</label>
        <div className="control has-icons-left has-icons-right">
          <input
            id="pwd"
            className={'input ' + (pwdOK ? 'is-primary' : 'is-danger')}
            type="password"
            placeholder={choosenLang.pwd}
            value={pwd}
            onChange={(e) => onPwdChange(e.target.value)}
          />
          <span className="icon is-small is-left">
            <i className="fa fas fa-lock"></i>
          </span>
          {!pwdOK && (
            <span className="icon is-small is-right">
              <i className="fa fa-exclamation-triangle"></i>
            </span>
          )}
        </div>
        <p className="help is-danger">
          {pwdOK ? '' : pwd.length > 0 ? choosenLang.alertPwd : ''}
        </p>
      </div>
      <Link
        className="is-size-6"
        to="/"
        onClick={(e) => {
          onPwdLost()
          e.preventDefault()
        }}
      >
        {choosenLang.pwdLost}
      </Link>
      <div className="field is-grouped is-grouped-right">
        <div className="control">
          <button
            className="button is-link"
            disabled={!emailOK || !pwdOK}
            onClick={onSubmit}
          >
            {choosenLang.identify}
          </button>
        </div>
      </div>
    </>
  )
}

export default LoginBox
